module.exports = __webpack_public_path__ + "821785e7ea8bbdcfa74e28b47d52e1d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/trickstrat/myplaybook.png
// module id = 1091
// module chunks = 0